<template>
    <div>
        <list-page getter="unsolds"
                   sort-by-prop="make"
                   :sort-by-desc-prop="0"
                   :table-fields="fields"
                   :enable-selection="true"
                   @selectVehicle="onSelect"
                   :disableHead="disableHead"
                   :hidePrices="hidePrices"
                   :showRepFilter="$userIsRole('super_admin') || ($userIsRole('sales') && loggedInUser.shared_sales_rep && loggedInUser.shared_sales_rep.length)"
                   :userListNullLabel="$userIsRole('super_admin') || ($userIsRole('sales') && loggedInUser.shared_sales_rep && loggedInUser.shared_sales_rep.length) ? 'All' : '-'"
                   :sortByProp="sold_date"
                   :sortByDescProp="true"
                   :filterBySharedSalesReps="true"
                   :hideAddNew="true">
            <template v-slot:title="">
                SBL Unsold Stock
            </template>
            <template v-slot:right_buttons="">
                <a class="btn" @click.prevent="openSendEmailModalFunc()">Send Email</a>
            </template>
        </list-page>
        <vehicle-stock-send-email :vehicle-ids="selected" v-model="openSendEmailModal"/>
    </div>
</template>
<script>
    import ListPage from './ListPage'
    import {numberWithCommas} from '../../util/common'
    import VehicleStockSendEmail from "./VehicleStockSendEmail";
    export default {
        props: [
            'disableHead',
            'hidePrices'
        ],
        components: {
            'list-page': ListPage,
            VehicleStockSendEmail
        },
        data(){
            return {
                selected: [],
                openSendEmailModal: false,
                fields: [
                    {label: 'Purchased', key: 'sold_date',sortable: true},
                    {label: 'Vehicle', key: 'vehicle'},
                    {label: 'Make', key: 'make',sortable: true},
                    {label: 'Model', key: 'model', sortable: true},
                    {label: 'Chassis', key: 'chassis', sortable: true},
                    this.$userIsAdmin() ? {label: 'CO2 (indication only)', key: 'co2_text', sortable: true} : null,
                    {label: 'Yr', key: 'year',sortable: true},
                    {label: 'Kms', key: 'mileage', sortable: true},
                    {label: 'Colour', key: 'color', sortable: true},
                    {label: 'Dr', key: 'doors', sortable: true},
                    {label: 'CC', key: 'engine_capacity', sortable: true},
                    {label: 'Trans', key: 'transmission', sortable: true},
                    {label: 'FL', key: 'fuel_type', sortable: true},
                    {label: 'Cnd', key: 'condition', sortable: true},
                    {label: 'Equip', key: 'equipment', sortable: true},
                    {label: 'Price', key: 'price', sortable: false, formatter: (value, key, item) => {
                        if (item.user_region_price) {
                            let sign = item.user_region_price.currency_sign
                            // let code = item.user_region_price.currency_code
                            // in unsold use offer_price if available
                            let price = item.offer_price ? item.offer_price : item.user_region_price.pivot.price
                            if (price > 9999) {
                                price = numberWithCommas(price)
                            }
                            return `${sign}${price}`
                        }
                        return 'ASK'
                    }},
                    {label: 'Actions', key: 'actions'},
                ],
            }
        },
        methods: {
            onSelect(vehicle, all_selected){
                this.selected = all_selected
            },
            openSendEmailModalFunc(){
                if (this.selected.length) {
                    this.openSendEmailModal = true
                } else {
                    this.$message.error('Please select at least 1 vehicle to send an email.');
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/UnsoldsStock.vue